import React from 'react';
import { StyledCloseBtn } from './styled';
import { CloseOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { metricSelector, selectedMetricSelector } from '@store/metricsChartContainer/selectors';
import { setMetrics } from '@store/metricsChartContainer/actions';
import { track } from '@utils';
import { REMOVE_CHART } from '@src/utils/sensor/track';
import { Button } from 'antd';

function RemoveMetric({ metric }) {
  const dispatch = useDispatch();
  const selectedMetric = useSelector(selectedMetricSelector);
  const metrics = useSelector(metricSelector);
  const confirm = () => {
    track({ event: REMOVE_CHART, data: { metric } });

    const newMetricsList = Array.from(metrics).filter((m) => m !== metric);
    dispatch(setMetrics(newMetricsList));
  };
  const disableIcon = metric === selectedMetric;
  return (
    <StyledCloseBtn>
      <Button
        size="small"
        type="text"
        icon={<CloseOutlined />}
        onClick={confirm}
        disabled={disableIcon}
      />
    </StyledCloseBtn>
  );
}

export default RemoveMetric;
